var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Banner'),_vm._v(" "),_c('AcercaHome'),_vm._v(" "),_c('PlanComercial'),_vm._v(" "),_c('Videos'),_vm._v(" "),_c('CursosHome'),_vm._v(" "),_c('Testimonios'),_vm._v(" "),_c('Clientes'),_vm._v(" "),_c('Podcast'),_vm._v(" "),_c('Libro'),_vm._v(" "),_c('Newsletter'),_vm._v(" "),_c('Instagram'),_vm._v(" "),_c('Contacto')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3918c329","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = null
// module chunks = 